import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../apiConfig';

type User = { id: number; email: string; roles: string[] };

type AuthContextType = {
    user: User | null;
    permissions: string[];
    loading: boolean;
};

const defaultContext: AuthContextType = {
    user: null,
    permissions: [],
    loading: true,
};

const AuthContext = createContext<AuthContextType>(defaultContext);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [auth, setAuth] = useState<AuthContextType>(defaultContext);

    useEffect(() => {
        const fetchAuth = async () => {
            try {
                const res = await api.get(`/api/auth/permissions`);
                const { id, email, roles, permissions } = res.data;
                setAuth({ user: { id, email, roles }, permissions, loading: false });
            } catch (err) {
                console.error('Failed to load auth info:', err);
                setAuth(prev => ({ ...prev, loading: false }));
            }
        };

        fetchAuth();
    }, []);

    return (
        <AuthContext.Provider value={auth}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);